<template>
    <div v-if="show" class="tecnomap-container">
        <tecno-map
            ref="map"
            class="tecnomap-drawer"
            :options="finalOptions"
            :section="section"
            @ready="mapReady"
            @destroy="ready = false"
            :loading="!ready"
            :class="{'is-drawing': currentMode != null}"
            >
        </tecno-map>
        
        <div v-show="ready" class="tecnomap-left-sidebar">
            <button @click.stop="locate()" class="tecnomap-controls-element btn btn-google geoloc" :class="{'loopator': isGeolocating}">
                <img :src="'/img/icons/' + $root.network + '/geo.svg'" class="btn-control-map" />
                <span>
                    <img src="/img/icons/arrow-tooltip.svg" class="ar"/>
                    {{ lang.labels.geoloc }}
                </span>
            </button>
            <div class="draw-tools">
                <button @click.stop="enableDraw('hand')" class="tecnomap-controls-element btn btn-google" :class="{'active': currentMode == 'hand'}">
                    <img :src="'/img/icons/' + $root.network + '/draw-map.svg'" class="btn-control-map" />
                    <span>
                        <img src="/img/icons/arrow-tooltip.svg" class="ar"/>
                        {{ lang.labels.draw_polygon }}
                    </span>
                </button>
                <button @click.stop="enableDraw('circle')" class="tecnomap-controls-element btn btn-google near-you" :class="{'active': currentMode == 'circle'}">
                    <img :src="'/img/icons/' + $root.network + '/near-you.svg'" class="btn-control-map" />
                    <span>
                        <img src="/img/icons/arrow-tooltip.svg" class="ar"/>
                        {{ lang.labels.draw_circle }}
                    </span>
                </button>
            </div>
            <div class="zoom-btn">
                <button @click.stop="zoomIn()" class="tecnomap-controls-element btn zoom-in" :disabled="zoomExceeded.zoomIn">+</button>
                <button @click.stop="zoomOut()" class="tecnomap-controls-element btn zoom-out" :disabled="zoomExceeded.zoomOut">–</button>
            </div>
        </div>
        
        <div v-show="ready" class="tecnomap-controls">
         

            <button @click.stop="reset()" class="tecnomap-controls-element btn btn-google">{{ lang.labels.reset }}</button>

            
            <div class="tecnomap-infobar-container">
                <div class="tecnomap-infobar" :class="{'text-danger': infobarError}" v-html="infobarText"></div>
            </div>

            <button v-show="featuresCount == 0" @click.prevent="enableDraw(mode)" class="tecnomap-controls-element btn btn-network right-btn">{{ lang.labels.draw_on_map }}</button>
            <button v-show="featuresCount > 0" @click.prevent="redirectToListing" class="tecnomap-controls-element btn btn-network right-btn">{{ redirectListingLabel }}</button>
        </div>
        <div v-show="ready" class="tecnomap-header">
            <div class="float-right float-right p-2 pr-1" @click.prevent="hide()"><img src="/img/icons/close.svg"></div>
        </div>
        <map-carousel v-if="$root.is_mobile" :estates="estatesCarousel"></map-carousel>
        <div class="modal-backdrop" @click.prevent="hide()"></div>

        <modal
            v-if="! disclaimerShown"
            :auto-open="false"
            name="drawer-disclaimer"
            ref="drawer-disclaimer"
            title="Disegno multiplo su mappa"
            extra-class="bottom-modal drawer-disclaimer-modal"
        >
            <template slot="body">
                <drawer-disclaimer />
            </template>
        </modal>
    </div>
</template>

<script>
import DrawerDisclaimer from './DrawerDisclaimer'
import MapCarousel from '../estates/MapCarousel'
import Modal from '../Modal'
import TecnoMap from './Map'

import { uriParams } from '../../helpers/urls'

export default {
    components: {
        'drawer-disclaimer': DrawerDisclaimer,
        'map-carousel': MapCarousel,
        'modal': Modal,
        'tecno-map': TecnoMap,
    },

    props: {
        options: {
            type: Object,
            default: function() {
                return {
                    minZoom: 10,
                    maxZoom: 18,
                    currentZoom: 13,
                    style: '/core/v1/' + this.$root.country_full_name + '/style.json',

                    mapCenter: {
                        locate: false
                    },

                    features: {
                        uriCoords: false,
                        scrollZoom: false,
                        dragRotate: false,
                        touchZoomRotate: true
                    },

                    modules: {
                        navigationControl: {
                            zoom: {
                                listen: true
                            },
                            geolocate: {
                                listen: true
                            }
                        },

                        drawer: {
                            maxRadiusKm: 2,
                            modes: ['circle', 'hand'],
                            maxPolygons: 10,
                            insideColor: '#078c33',
                            outsideColor: '#00d054',
                            fillColor: '#089642',
                            textColor: '#fff',
                            listen: true
                        },

                        geocoder: {
                            origin: window.tecnomapsEndpoint,
                            endpoint: 'v2/services/geocoder',
                            jumpTo: true
                        },

                        poi: {
                            country: this.$root.country_full_name,
                            endpoint: window.tecnomapsEndpoint + '/v2/services/poi',
                            fixed: ['public_transport', 'ev_charging']
                        }
                    }
                }
            }
        },

        contract: {
            type: String,
            required: true
        },

        section: {
            type: String,
            required: true
        },

        sector: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            expired: false,
            show: false,
            ready: false,
            mode: null,
            features: [],
            shape: {},
            shapeCenter: [],
            area: 0,
            estatesCarousel: [],
            overrideOptions: {},

            infobarError: false,
            infobarMessage: null,

            isGeolocating: false,
            currentMode: null,
            isDragging: false,
            isCircleEditable: false,
            userLocationAllowed: false,

            zoomExceeded: {
                zoomIn: false,
                zoomOut: false
            },

            estatesCount: 0
        }
    },

    computed: {
        disclaimerShown() {
            return $cookies.get('drawer_disclaimer_shown')
        },

        infobarText() {
            if(this.infobarMessage != null)
                return this.infobarMessage
            else if(this.isCircleEditable == true)
                return this.lang.labels.drag_to_edit_circle;
            else if(this.currentMode == null)
            {
                if(this.featuresCount >= 1)
                    return this.lang.labels.keep_drawing_polygons;
                else
                    return this.lang.labels.draw_multiple_polygons;
            }
            else
            {
                if(this.currentMode == 'hand')
                    return this.isDragging ? this.lang.labels.release_to_draw : this.lang.labels.click_to_draw;
                else
                    return this.lang.labels.click_to_circle;
            }
        },

        featuresCount() {
            return this.features.length;
        },

        lang() {
            return this.$root.lang.tecnomap
        },

        estatesListURL() {
            let urlRedirect = '/'

            if(['res', 'ind', 'tur'].includes(this.sector))
            {
                urlRedirect += this.$root.lang.estates_url.contract[this.contract]
                urlRedirect += this.$root.lang.estates_url.sector[this.sector]
                urlRedirect += '/' + this.$root.lang.estates_url.type.default + '/mappa.html'
            }
            else if (this.sector == 'can') {
                urlRedirect += 'nuove-costruzioni/mappa.html'
            }

            return urlRedirect
        },

        finalOptions() {
            return {
                ...this.options,
                ...this.overrideOptions
            }
        },

        redirectListingLabel() {
            var count = (this.estatesCount > 0) ? this.estatesCount : ''
            return this.lang.labels.show_estates.replace(':count', count)
        }
    },

    watch: {
        // whenever question changes, this function will run
        show: function (newValue) {
            if(newValue)
            {
                document.body.classList.add('modal-open')
                this.registerListeners()
            }
            else
            {
                document.body.classList.remove('modal-open')
                this.unregisterListeners()
            }
        }
    },

    methods: {
        registerListeners()
        {
            window.addEventListener('tecnomap.drawer.featuresUpdated', this.trackFeaturesChanges);
            window.addEventListener('tecnomap.drawer.shapeUpdated', this.updateMarkerByPolygons);
            window.addEventListener('tecnomap.drawer.markerClusterClick', this.showEstateDetails);
            window.addEventListener('tecnomap.drawer.markerClick', this.showEstateDetails);
            window.addEventListener('tecnomap.drawer.limitExceeded', this.showLimitExceeded);
            window.addEventListener('tecnomap.click', this.mapClicked);

            window.addEventListener('tecnomap.navigationControl.geolocate.start', this.startGeolocating);
            window.addEventListener('tecnomap.navigationControl.geolocate.end', this.endGeolocating);
            window.addEventListener('tecnomap.navigationControl.geolocate.error', this.endGeolocating);
            window.addEventListener('tecnomap.navigationControl.geolocate.success', this.endGeolocating);

            window.addEventListener('tecnomap.drawer.loaded', this.drawerLoaded);
            window.addEventListener('tecnomap.drawer.modeChange', this.updateCurrentDrawMode);

            window.addEventListener('tecnomap.drawer.dragStart', this.dragStart);
            window.addEventListener('tecnomap.drawer.dragStop', this.dragStop);

            window.addEventListener('tecnomap.drawer.circle.changeStart', this.circleChangeStart);
            window.addEventListener('tecnomap.drawer.changeEnd', this.circleChangeEnd);
            window.addEventListener('tecnomap.navigationControl.zoom.exceeded', this.mapZoomExceeded);
        },

        unregisterListeners()
        {
            window.removeEventListener('tecnomap.drawer.featuresUpdated', this.trackFeaturesChanges);
            window.removeEventListener('tecnomap.drawer.shapeUpdated', this.updateMarkerByPolygons);
            window.removeEventListener('tecnomap.drawer.markerClusterClick', this.showEstateDetails);
            window.removeEventListener('tecnomap.drawer.markerClick', this.showEstateDetails);
            window.removeEventListener('tecnomap.drawer.limitExceeded', this.showLimitExceeded);
            window.removeEventListener('tecnomap.click', this.mapClicked);

            window.removeEventListener('tecnomap.navigationControl.geolocate.start', this.startGeolocating);
            window.removeEventListener('tecnomap.navigationControl.geolocate.end', this.endGeolocating);
            window.removeEventListener('tecnomap.navigationControl.geolocate.error', this.endGeolocating);
            window.removeEventListener('tecnomap.navigationControl.geolocate.success', this.endGeolocating);
            window.removeEventListener('tecnomap.drawer.modeChange', this.updateCurrentDrawMode);

            window.removeEventListener('tecnomap.drawer.dragStart', this.dragStart);
            window.removeEventListener('tecnomap.drawer.dragStop', this.dragStop);

            window.removeEventListener('tecnomap.drawer.circle.changeStart', this.circleChangeStart);
            window.removeEventListener('tecnomap.drawer.changeEnd', this.circleChangeEnd);
            window.removeEventListener('tecnomap.navigationControl.zoom.exceeded', this.mapZoomExceeded);
        },

        drawerLoaded(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                console.log('Portale/Maps/Drawer - Receive: tecnomap.drawer.loaded')
                // this.enableDraw(this.mode)
            }
        },

        display() 
        {
            this.show = true;
        },

        hide() 
        {
            this.estatesCount = 0;
            this.show = false;
            this.features = [];
        },

        reset()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.drawer.reset', { detail: { id: this.$refs.map.id }}));
        },

        locate()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.navigationControl.geolocate', { detail: { id: this.$refs.map.id }}))
        },

        zoomIn()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.navigationControl.zoom.in', { detail: { id: this.$refs.map.id }}))
        },

        zoomOut()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.navigationControl.zoom.out', { detail: { id: this.$refs.map.id }}))
        },

        enableDraw(mode) 
        {
            window.dispatchEvent(new CustomEvent('tecnomap.drawer.changeMode', { detail: { id: this.$refs.map.id, mode: mode }}));
        },

        startGeolocating(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isGeolocating = true
            }
        },

        endGeolocating(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isGeolocating = false
            }
        },

        dragStart(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isDragging = true
            }
        },

        dragStop(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isDragging = false
            }
        },

        updateCurrentDrawMode(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.currentMode = event.detail.mode
            }
        },

        circleChangeStart(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isCircleEditable = true
            }
        },

        circleChangeEnd(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isCircleEditable = false
            }
        },

        mapZoomExceeded(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.zoomExceeded = {
                    zoomIn: event.detail.zoomIn,
                    zoomOut: event.detail.zoomOut
                }
            }
        },

        mapReady()
        {
            this.ready = true
            let params = uriParams();

            if(params['polygon_id'] != undefined && this.expired == false)
            {
                this.showInfobar(this.lang.labels.loading_polygons);
                axios.get('/api/estates/get-polygons', {
                    params: {
                        id: params['polygon_id']
                    }
                })
                .then((response) => {
                    window.dispatchEvent(new CustomEvent('tecnomap.drawer.setPolygons', { detail: { id: this.$refs.map.id, featureCollection: response.data }}));
                    this.resetInfobar();
                })
                .catch((error) => {
                    if(error.data && error.data.response && error.data.response.message)
                        this.showInfobar(error.data.response.message, true)
                    else
                        this.showInfobar('Errore durante la richiesta! Si prega di riprovare.', true);
                })
            }
        },

        redirectToListing()
        {
            // console.log('Portale/Maps/Drawer - redirectToListing', this.features)

            axios.post('/api/estates/save-polygons', {
                features: this.features,
                shape: this.shape,
                center: this.shapeCenter,
                area: this.area,
            })
            .then((response) => {
                window.location = this.estatesListURL + '?polygon_id=' + response.data.polygon_id;
            })
            .catch((error) => {
                if(error.data && error.data.response && error.data.response.message)
                    this.showInfobar(error.data.response.message, true)
                else
                    this.showInfobar('Errore durante la richiesta! Si prega di riprovare.', true);
            })
        },

        trackFeaturesChanges(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                // console.log('Portale/Maps/Drawer - trackFeaturesChanges', event)
                this.features = event.detail.features;
                this.resetInfobar();
            }
        },

        updateMarkerByPolygons(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                // console.log('Portale/Maps/Drawer - updateMarkerByPolygons', event)
                this.shape = event.detail.shape;
                this.shapeCenter = event.detail.center;
                this.area = event.detail.area;

                this.showInfobar(this.lang.labels.loading_estates);
                axios.post('/api/estates/search-by-polygons', {
                    area: event.detail.area,
                    shape: event.detail.shape,
                    contract: this.contract,
                    sector: this.sector
                })
                .then((response) => {
                    window.dispatchEvent(new CustomEvent('tecnomap.drawer.setMarkers', { detail: { id: this.$refs.map.id, featureCollection: response.data, bounds: false }}));
                    this.estatesCount = response.data.features.length
                    this.resetInfobar();
                })
                .catch((error) => {
                    this.estatesCount = 0
                    if(error.data && error.data.response && error.data.response.message)
                        this.showInfobar(error.data.response.message, true)
                    else
                        this.showInfobar('Errore durante la richiesta! Si prega di riprovare.', true);
                })
            }
        },

        showEstateDetails(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                // console.log('Portale/Maps/Drawer - showEstateDetails', event);

                window.isLoading()
                axios.get('/api/estates/search-by-ids', {
                    params: {
                        ids: event.detail.features.map((feature) => feature.id),
                        section: this.section
                    }
                })
                .then((response) => {
                    if(this.$root.is_mobile)
                    {
                        this.estatesCarousel = response.data
                    }
                    else
                    {
                        window.dispatchEvent(new CustomEvent('tecnomap.drawer.attachMarkerPopup', { detail: { 
                            id: this.$refs.map.id,
                            coordinates: event.detail.coordinates,
                            html: '<div id="vue-map-list-estate-card"></div>'
                        }}));

                        var EstateCard = Vue.extend(MapCarousel);

                        new EstateCard({
                            propsData: { 
                                estates: response.data,
                                extLang: this.$root.lang.estate_card
                            },
                        }).$mount('#vue-map-list-estate-card')
                    }
                    this.resetInfobar();
                })
                .catch((error) => {
                    if(error.data && error.data.response && error.data.response.message)
                        this.showInfobar(error.data.response.message, true)
                    else
                        this.showInfobar('Errore durante la richiesta! Si prega di riprovare.', true);
                })
                .then(() => {
                    window.stopLoading()
                })
            }
        },

        mapClicked(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                // console.log('Portale/Maps/Drawer - mapClicked', event);
                this.estatesCarousel = [];
            }
        },

        resetInfobar()
        {
            this.infobarMessage = null
            this.infobarError = false
        },

        showInfobar(message, error = false)
        {
            this.infobarMessage = message
            this.infobarError = error
        },

        showLimitExceeded(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                // console.log('Portale/Maps/Drawer - showLimitExceeded', event);

                if(event.detail.exceeded)
                {
                    this.showInfobar('Hai raggiunto il raggio massimo!', true);
                }
                else
                {
                    this.resetInfobar();
                }
            }
        }
    },

    created() {
        // console.log('Portale/Maps/Drawer - created');
        if(navigator && navigator.permissions){
            navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                this.userLocationAllowed = (result.state == 'granted')
            })
        }

        if(this.$root.network == 'tecnorete')
        {
            this.options.modules.drawer = {
                ...this.options.modules.drawer,
                insideColor: '#003596',
                outsideColor: '#53BAFF',
                fillColor: '#003596',
                textColor: '#ffffff',
            }
        }
    },

    mounted() {
        // console.log('Portale/Maps/Drawer - mounted');
        window.events.$on('Drawer.invoke', event => {
            if(event.expired == true)
            {
                this.expired = true
            }

            let params = uriParams();
            
            if(event.mode == 'geolocate')
            {
                this.userLocationAllowed = true
                this.overrideOptions = {
                    mapCenter: {
                        marker: true,
                        locate: true
                    }
                }
                this.mode = 'circle'
            }
            else
            {
                this.overrideOptions = {
                    mapCenter: {
                        locate: (this.userLocationAllowed && params['polygon_id'] == undefined),
                        marker: false
                    }
                }
                this.mode = event.mode
            }

            this.display()
            this.resetInfobar()
        });

        if(this.show) this.registerListeners()
    },

    beforeDestroy() {
        // console.log('Portale/Maps/Drawer - beforeDestroy');
        this.unregisterListeners()
    },
}
</script>